<template>
  <qx-card title="">
    <section slot="titleLeft">
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope" >
                <section
                    v-if="scope.column.property === 'carDriverPhone'"
                >
                  <span v-if="scope.row.carDriverPhone === 'isTotal'"></span>
                  <span v-else>{{
                      scope.row[scope.column.property]
                    }}</span>

                </section>
                <section
                    v-if="scope.column.property !== 'carDriverPhone'"
                    :class="{ error: scope.$index === 0 }"
                >
                  <span  v-if="scope.column.property === 'grossProfitMargin'">
                     {{ scope.row[scope.column.property] +'%'}}
                  </span>
                 <span v-else>{{ scope.row[scope.column.property] }}</span>
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              fixed="right"
              width="100"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isCenter="true"
                  :btnList="[
                  {
                    showCondition: scope.row.carDriverPhone!=='isTotal',
                    name: '查看',
                    event: () => toDetail(scope.row),
                  }
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
// import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
} from 'api/car';
import {driverOperateReport} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    // ExportBtn,
    TableBtn,
    TableSetting,
  },
  props: {
    dependTime: {
      type: Array,
      default: () => ([]),
    },
    orgId: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'userId',
        title: [ // 表头
          { prop: 'carDriverMan', label: '主驾姓名' },
          { prop: 'carDriverPhone', label: '主驾电话' },
          { prop: 'orgName', label: '归属部门' },
          { prop: 'orderCount', label: '订单数' },
          { prop: 'amountReceivable', label: '应收金额' },
          { prop: 'oilFee', label: '油费' },
          { prop: 'roadAndBridgeFee', label: '路桥费' },
          { prop: 'maintenanceFee', label: '维修保养费' },
          { prop: 'otherExpenses', label: '其他费用' },
          { prop: 'carDriverSalary', label: '主驾工资' },
          { prop: 'copilotSalary', label: '副驾工资' },
          { prop: 'grossProfit', label: '毛利' },
          { prop: 'grossProfitMargin', label: '毛利率' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverOperateReport,
    toDetail (item) {
      this.jump({
        label: '司机订单详情',
        url: `/manage/report/operate/driverOperateReportDetail?id=${item.carDriverPhone}&dependTimeBegin=${this._props.dependTime[0] || ''}&dependTimeEnd=${this._props.dependTime[1] || ''}&orgId=${this._props.orgId}`,
        // full: true,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.isTotal{
  color:red
}
</style>

